'use client'

import dynamic from 'next/dynamic'

export const CursorsClient = dynamic(() => import('./cursors').then(m => m.Cursors), {
  ssr: false,
})
